export default "__VITE_ASSET__DL6Bv5TH__"